/**
 * Available Markup for Stepper Step Component
 */
export var StepperStepMarkup;
(function (StepperStepMarkup) {
    StepperStepMarkup["P"] = "p";
    StepperStepMarkup["SPAN"] = "span";
    StepperStepMarkup["DIV"] = "div";
    StepperStepMarkup["A"] = "a";
})(StepperStepMarkup || (StepperStepMarkup = {}));
//# sourceMappingURL=StepperStepEnum.js.map